import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom'
//import * as firebase from 'firebase'


//import './index.css';
import 'bootstrap/dist/css/bootstrap.min.css'; // from npm
import 'font-awesome/css/font-awesome.min.css'; // from npm
import './sbadmin/metisMenu.min.css'
import './sbadmin/sb-admin-2.css'



import App from './components/App/App';

import registerServiceWorker from './registerServiceWorker';

ReactDOM.render((
  <BrowserRouter>
    <App />
  </BrowserRouter>
), document.getElementById('root'));

//ReactDOM.render(<App />, document.getElementById('root'));


registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js